import type { SubmissionStatus } from '../lib/types.ts';

const COLORS: Record<SubmissionStatus, { bg: string; fg: string; border: string; label: string }> = {
  uploading: { bg: 'rgba(196,155,255,0.12)', fg: '#C49BFF', border: 'rgba(196,155,255,0.3)', label: 'UPLOADING' },
  submitted: { bg: 'rgba(0,212,196,0.12)', fg: '#00D4C4', border: 'rgba(0,212,196,0.3)', label: 'SUBMITTED' },
  processing: { bg: 'rgba(0,212,196,0.18)', fg: '#00D4C4', border: 'rgba(0,212,196,0.4)', label: 'PROCESSING' },
  processed: { bg: 'rgba(0,232,122,0.14)', fg: '#00E87A', border: 'rgba(0,232,122,0.32)', label: 'PROCESSED' },
  invalid: { bg: 'rgba(255,107,122,0.12)', fg: '#FF6B7A', border: 'rgba(255,107,122,0.3)', label: 'INVALID' },
  failed: { bg: 'rgba(255,107,122,0.16)', fg: '#FF6B7A', border: 'rgba(255,107,122,0.35)', label: 'FAILED' },
};

interface StatusBadgeProps {
  status: SubmissionStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const c = COLORS[status];
  return (
    <span
      style={{
        display: 'inline-block',
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 10,
        letterSpacing: '0.12em',
        padding: '4px 10px',
        borderRadius: 4,
        background: c.bg,
        color: c.fg,
        border: `1px solid ${c.border}`,
        whiteSpace: 'nowrap',
      }}
    >
      {c.label}
    </span>
  );
}
